import { Stack, Typography } from "@mui/material";
import { SignUpButtons } from "Components/Transactions/Anonymous/SignUpOptions/SignUpButtons";
import { Trans } from "react-i18next";
import { Resources, useResource } from "Translations/Resources";

const ComponentResources = Resources.Transactions.Anonymous;

type Props = {
  affiliateCode?: string;
};

export const SignupOptions = ({ affiliateCode }: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={4}>
      <Typography variant="h6" fontWeight={600} textAlign="center" px={4}>
        {t(ComponentResources.SignupTitle)}
      </Typography>
      <Typography color="text.secondary" textAlign="center" lineHeight="24px">
        <Trans components={{ newline: <br /> }}>
          {t(ComponentResources.Benefits)}
        </Trans>
      </Typography>
      <SignUpButtons affiliateCode={affiliateCode} />
    </Stack>
  );
};
